// @ts-ignore
import {Routes} from '@angular/router';

import {GatewayComponent} from './pages/gateway/gateway.component';
import {LoginComponent} from './pages/login/login.component';
import {GplEdicaoProdutosComponent} from './pages/gpl-edicao-produtos/gpl-edicao-produtos.component';
import {authGuard} from './guards/auth.guard';
import {GplRelatoriosComissoesComponent} from "./pages/gpl-relatorios-comissoes/gpl-relatorios-comissoes.component";
import {GplConferenciaClienteComponent} from './pages/gpl-conferencia-cliente/gpl-conferencia-cliente.component';
import {PedidoPublicoComponent} from './pages/pedido-publico/pedido-publico.component';

export const routes: Routes = [
    {path: 'login', component: LoginComponent},

    {path: 'pedidos/:chave', component: PedidoPublicoComponent},

    {path: 'home', component: GatewayComponent, canActivate: [authGuard]},

    {
        path: 'gpl-edicaodeprodutos',
        component: GplEdicaoProdutosComponent,
        canActivate: [authGuard]
    },

    {
        path: 'gpl-relatorios-comissoes',
        component: GplRelatoriosComissoesComponent,
        canActivate: [authGuard]
    },

    {
        path: 'gpl-conferencia-cliente',
        component: GplConferenciaClienteComponent,
        canActivate: [authGuard]
    },

    {path: '', redirectTo: 'login', pathMatch: 'full'},

    {path: '**', redirectTo: 'login'}
];
